<div class="registration-container">
    <form [formGroup]="loanRequestRequestForm" (ngSubmit)="submitLoanApplication()" class="form-container">
        <h2 class="section-title">Apply Loan</h2>
        <div class="form-section grid-2">
            <mat-form-field appearance="outline">
                <mat-label>Employee Number</mat-label>
                <input matInput [value]="empNo" readonly>
            </mat-form-field>
            <mat-form-field appearance="outline" class="reason-field">
                <mat-label>Amount</mat-label>
                <input matInput formControlName="loan_amount" required (keypress)="allowOnlyNumbers($event)">
            </mat-form-field>
            <mat-form-field appearance="outline" class="reason-field">
                <mat-label>First Intallment</mat-label>
                <input matInput formControlName="first_installment_amount" required
                    (keypress)="allowOnlyNumbers($event)">
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Payment Date</mat-label>
                <input matInput [matDatepicker]="fromPicker" formControlName="payment_date" required>
                <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                <mat-datepicker #fromPicker></mat-datepicker>
                <!-- <mat-error *ngIf="salaryAdvanceRequestForm.get('payment_date')?.hasError('required')">
                    Start Date is required
                </mat-error> -->
            </mat-form-field>
            <!-- <mat-form-field appearance="outline" class="leave-type">
                <mat-label>Guarantor</mat-label>
                <mat-select formControlName="guarantor_id" required>
                    <mat-option *ngFor="let c of guarantors$ | async" [value]="c.id">
                        {{ c.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field> -->
            <!-- <mat-form-field appearance="outline" class="leave-type">
                <mat-label>Guarantor</mat-label>
                <input type="text" matInput [matAutocomplete]="auto" formControlName="guarantor_id"
                    placeholder="Select or type guarantor" />
                <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption>
                    <mat-option *ngFor="let g of filteredGuarantors$ | async" [value]="g.name">
                        {{ g.name }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field> -->

            <mat-form-field appearance="outline" class="leave-type">
                <mat-label>Guarantor</mat-label>

                <input type="text" matInput [matAutocomplete]="auto" placeholder="Select or type guarantor"
                    [formControl]="guarantorControl" />

                <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption [displayWith]="displayGuarantorName"
                    (optionSelected)="onGuarantorSelected($event.option.value)">
                    <mat-option *ngFor="let g of filteredGuarantors$ | async" [value]="g">
                        {{ g.name }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>


            <div class="file-upload">
                <label>Affidavit*</label>
                <div class="upload-wrapper">
                    <button mat-raised-button color="primary" type="button" (click)="afdtFileInput.click()">
                        <mat-icon>upload_file</mat-icon> Choose File
                    </button>
                    <span class="file-name">{{ affidavitFileName || 'No file chosen' }}</span>
                    <input #afdtFileInput type="file" (change)="onFileChange($event, 'CR')" hidden />
                </div>
            </div>
        </div>
        <div class="form-section grid-2">
            <mat-form-field appearance="outline" class="reason-field">
                <mat-label>Reason</mat-label>
                <textarea style="height: 100px !important;" matInput formControlName="reason" rows="3"
                    required></textarea>
            </mat-form-field>
        </div>
        <div class="form-actions">
            <button mat-raised-button color="primary" type="submit" class="submit-vendor-btn">
                <span *ngIf="!isLoading">Apply</span>
                <span *ngIf="isLoading" class="loader"></span>
            </button>
        </div>
    </form>
</div>